// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"642a59fe","453":"fa2c8a61","732":"a69d7b66"}[chunkId] + ".chunk.js");